import VideoPlayer from 'components/shared/video/video';
import styles from './videos.module.scss';

const Videos = ({ data }) => {
  const { videos, anchorId } = data;

  return (
    <section id={anchorId} className={styles.wrapper}>
      <div className={styles.container}>
        {videos.map(video => (
          <div className={styles.videoContainer}>
            <h2 className={styles.title}>{video.title}</h2>
            <p className={styles.headerText}>{video.text}</p>
            <div className={styles.video}>
              <VideoPlayer
                thumbnail={video.media.thumbnail}
                source={video.media.video}
                controlsVersion={2} // play buton centered
                aspectRatio="9/16"
                className={styles.videoPlayer}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Videos;
